<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                     Date Value                                       │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <span :class="['date-value', { compact, MDY: CONFIG.UseUSDateFormat }]">
        <slot v-if="!value" />
        <template v-else>
            <span class="date-weekday" v-if="weekday">{{ weekday }}</span>
            <template v-if="CONFIG.UseUSDateFormat">
                <span class="date-month" v-if="month">{{ month }}</span>
                <span class="date-day" v-if="day" :data-accent="accent">{{ day }}</span>
            </template>
            <template v-else>
                <span class="date-day" v-if="day">{{ day }}</span>
                <span class="date-month" v-if="month">{{ month }}</span>
            </template>
            <span class="date-year" v-if="year">{{ year }}</span>
        </template>
    </span>
</template>
<style scoped>
    .date-weekday::after { content: ', '; }

    .date-value span:not(.date-weekday) + span::before { content: '-'; }
    .MDY span + span::before { visibility: hidden; }

    .date-day[data-accent]::after {
        content: attr(data-accent);
        font-size: 0.75em;
        vertical-align: top;
    }
</style>
<script>
    export default {
        name: 'DateValue',

        props: {
            value: [String, Number, Date],
            compact: Boolean,
            showWeekday: Boolean,
            hideYear: Boolean
        },
        
        computed: {
            date() {
                let date = this.value
                if (date) {
                    if (date.constructor !== Date) date = new Date(date)
                    return date
                }
            },

            weekday() {
                if (this.date && this.showWeekday) {
                    let weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
                    return weekdays[this.date.getDay()]
                }
            },

            month() {
                if (this.date) {
                    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    if (!this.CONFIG.UseUSDateFormat) months = months.map(month => month.slice(0, 3))

                    return months[this.date.getMonth()]
                }
            },

            day() {
                if (this.date) {
                    return this.CONFIG.UseUSDateFormat ? this.date.getDate() : `${100 + this.date.getDate()}`.slice(1)
                }
            },

            accent() {
                if (this.day) {
                    if ((this.day + 6) % 10 > 6)
                        if (![11, 12, 13].includes(this.day))
                            return ['st', 'nd', 'rd'][this.day % 10 - 1]

                    return 'th'
                }
            },

            year() {
                if (this.date && !this.hideYear) {
                    return this.date.getFullYear()
                }
            }
        }
    }
</script>
